import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { GetPunchoutApiParameter } from "@TKCCP/Services/tkccpPunchoutService";

type HandlerType = Handler<GetPunchoutApiParameter>;

export const DispatchUpdateLoadParameter: HandlerType = props => {
    props.dispatch({
        type: "Pages/PunchoutSecret/UpdateLoadParameter" as any,
        parameter: props.parameter,
    });
};

export const chain = [DispatchUpdateLoadParameter];

const updateLoadParameter = createHandlerChainRunner(chain, "UpdateLoadParameter");
export default updateLoadParameter;
